"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var mailListFilterViewStoreData = {
    filterContextMenuDisplayState: false,
};
exports.getStore = satcheljs_1.createStore('mailListFilterView', mailListFilterViewStoreData);
exports.store = exports.getStore();
//# sourceMappingURL=Store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-list-filter-store/lib/store/Store.js
// module id = 2079
// module chunks = 46 105